import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { useSnackbar } from '@weareopenr/component-library';
import { getBrandId } from 'src/helpers/getBrandId/getBrandId';
import { getInventoryItem } from 'src/api/getInventoryItem';
import { QueryKeys } from '../QueryKeys';
import { DetailedInventoryItem } from 'src/api/getInventoryItem/types';
import { getInventoryItemError } from 'src/mocks/data';

export const useInventoryItem = (
  id?: string,
  options?: UseQueryOptions<DetailedInventoryItem | null>,
): UseQueryResult<DetailedInventoryItem | null> => {
  const { showSnackbar } = useSnackbar();

  return useQuery<DetailedInventoryItem | null>({
    queryKey: [QueryKeys.inventoryItem, getBrandId(), id],
    queryFn: async () => getInventoryItem(id),
    enabled: !!id,
    onError: () => showSnackbar(getInventoryItemError),
    ...options,
  });
};
